/*
 * Public API surface of docuty-template-renderer
 */

// Module
export { DocutyTemplateRendererModule } from './lib/docuty-template-renderer.module';

// Components — Darstellung
export { TemplateStructureTreeComponent } from './lib/components/template-structure-tree/template-structure-tree.component';
export { PhonePreviewComponent } from './lib/components/phone-preview/phone-preview.component';

// Components — Designer (DOCU-1066)
export { FieldPaletteComponent, FieldType } from './lib/components/field-palette/field-palette.component';
export { FormCanvasComponent } from './lib/components/form-canvas/form-canvas.component';
export { FieldConfigPanelComponent } from './lib/components/field-config-panel/field-config-panel.component';
export { NestedLevelComponent } from './lib/components/nested-level/nested-level.component';

// Models
export {
  RendererFieldType,
  RendererField,
  RendererLevel,
  RendererForm,
  RendererSelectedNode,
} from './lib/models/renderer.models';

// Builder-Modell und Konvertierung Server-JSON <-> Editor-Struktur (DOCU-1066)
export {
  FormField,
  FormLevel,
  ApiFormFieldJson,
  ApiFormLevelJson,
  extractUnknownProps,
  generateUUID,
  generateFieldId,
  generateFieldLabel,
  generateLevelName,
  isTitleEligibleField,
  isFolderEligibleField,
  parseTemplateFieldId,
  mapApiTypeToBuilderType,
  mapBuilderTypeToApiType,
  convertApiFieldsToFormFields,
  convertApiLevelsToFormLevels,
  convertFieldToApiFormat,
  convertLevelToApiFormat,
} from './lib/utils/form-builder.utils';

// Laden/Speichern einer Vorlage im Designer (DOCU-1066)
export {
  TemplateLike,
  BuildAuditFormJsonOptions,
  DEFAULT_ROOT_LEVEL_NAME,
  createEmptyRootLevel,
  templateToRootLevel,
  buildAuditFormJson,
} from './lib/utils/template-mapping';

// Zustand und Operationen einer Designer-Sitzung (DOCU-1066)
export { FormBuilderSession } from './lib/utils/form-builder-session';
